import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const stats = [
  { label: "Projects Delivered", end: 250 },
  { label: "Happy Clients", end: 180 },
  { label: "Years Experience", end: 5 },
];

const Achievements = () => {
  return (
    <section className="bg-gradient-to-br from-gray-900 to-black py-20 text-white">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center">
        {stats.map(({ label, end }, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
            viewport={{ once: true }}
            className="hover:scale-105 transition-transform duration-300"
          >
            <h2 className="text-5xl font-bold text-cyan-400 drop-shadow-glow">
              <CountUp end={end} duration={3} />+
            </h2>
            <p className="mt-2 text-gray-300 text-lg">{label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Achievements;
